import { atom } from 'jotai';

export const offlineSimulatorVisibleAtom = atom(false);
